import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../services/api";

function AdminLogin() {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("")

    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();

        console.time("LOGIN");

        try {
            console.time("API");

            const response = await API.post("/api/admin/login", {
                email,
                password
            });

            localStorage.setItem("adminToken", response.data.token);

            navigate("/admin/dashboard");

        } catch (error) {
            console.error(error);
        }   
    }

    return (

        <div className="container mt-5">

            <h2>Admin Login</h2>

            <form onSubmit={handleLogin}>

                <input
                    className="form-control mb-3"
                    placeholder="Email"
                    onChange={(e) => setEmail(e.target.value)}
                />

                <input
                    type="password"
                    className="form-control mb-3"
                    placeholder="Password"
                    onChange={(e) => setPassword(e.target.value)}
                />

                <button className="btn btn-dark">
                    Login
                </button>

            </form>

        </div>
    )
}

export default AdminLogin;